module.exports = __webpack_public_path__ + "img/lighting.eca3b6ea.png";